import { RoutePageType } from "@routes/interfaces"
import ConviteFoto from "./pages/ConviteFoto"
import ConviteDados from "./pages/ConviteDados"
import ConviteLiveness from "./pages/ConviteLiveness"

const convitePages: RoutePageType[] = [
    {key: 'conviteDados', element: ConviteDados},
    {key: 'conviteFoto', element: ConviteFoto},
    {key: 'conviteLiveness', element: ConviteLiveness}
]

export default convitePages